<section>
  <datalist id="listmateriais">
    <select>
      <option *ngFor="let item of materiaisDisponiveis" [value]="item.descricao"></option>
    </select>
  </datalist>
</section>

<ngx-loading [show]="isProcessing"></ngx-loading>

<app-container-middle [height]="80" [isEditing]="this.form.get('id').value > 0">
  <section>
    <div class="row">
      <div class="col-md-12">
        <div class="box-header text-center">
          <h3 class="box-title">Entrada material</h3>
        </div> 
        <div style="float:right">
          <button type="button" class="btn btn-primary btn-shadow btn-block" (click)="selecionarArquivo()">Importar NF XML</button>
        </div>
      </div>

     
    </div>
    <div class="row">
      <div class="col-md-12">
        <form novalidate [formGroup]="form" id="form" (validSubmit)="submit()">
          <div class="form-row">
            <div class="col-md-6">
              <div class="col-md-12">
                <div class="form-group row">
                  <label for="" class="col-md-4 col-form-label">
                    Nº Documento
                  </label>
                  <div class="col-md-8">
                    <div class="input-group">
                      <input class="form-control" formControlName="numeroDocumento" type="text" maxlength="15"
                        required />
                      <div class="input-group-append cp" (click)="openModalSearch(modalPesquisar)"
                        title="Buscar documento">
                        <span class="input-group-text">
                          <i class="fa fa-search"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group row">
                  <label for="" class="col-md-4 col-form-label">Data/Hora</label>
                  <div class="col-md-8">
                    <input type="datetime-local" class="form-control text-center" formControlName="dataHoraEntrada"  max="9999-12-31T23:59:59" />
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group row">
                  <label for="" class="col-md-4 col-form-label">Empresa</label>
                  <div class="col-md-8">
                    <input type="text" class="form-control" formControlName="empresa" maxlength="60" />
                  </div>
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group row">
                  <label for="" class="col-md-4 col-form-label">CNPJ</label>
                  <div class="col-md-8">
                    <!--[textMask]="{mask: maskCnpj, guide: true}"-->
                    <input type="text" class="form-control" formControlName="cnpj" maxlength="14" />
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="">Observações</label>
                  <textarea rows="3" class="form-control" formControlName="observacao" style="resize: none;"></textarea>
                </div>
              </div>

              <div class="col-md-12 pt-1">
                <div class="form-group">
                  <label for="">Chave acesso NF</label>
                  <input type="text" class="form-control" formControlName="chaveAcesso" maxlength="44" />
                </div>
              </div>
       
              
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="divider2"></div>

    <div class="row">
      <div class="col-md-6">
        <div class="input-group mt-3">
          <input type="text" class="form-control fs09" list="listmateriais" id="datalistMateriais"
            placeholder="Pesquise por código, descrição, código NCM ou tipo material"
            (change)="changeDataListMateriais($event.target.value)" maxlength="200" />
          <div class="input-group-append cp" (click)="limparDataListMateriais()"
            title="limpar campo e recarregar lista completa de opções">
            <span class="input-group-text"><i class="fa fa-trash"></i></span>
          </div>
        </div>

        <div class="box-table-sm fs09 mt-3" style="height: 350px;">
          <table style="overflow-x: none;">
            <thead>
              <tr>
                <th colspan="4">Selecione um ou mais na lista, informe quantidade e o valor (opcional) e confirme
                </th>
              </tr>
              <tr>
                <th>Código / NCM</th>
                <th>Descrição</th>
                <th>Quantidade</th>
                <th>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of this.materiaisListGrid" id="{{item.materialId}}" class="alert cp" [ngClass]="{ 'tr-info': item.marcado }">
                <td class="text-center" (click)="selectMateriais(item.materialId)">
                  {{ item.codigo }} <br /> <b>{{item.ncm }}</b>
                </td>
                <td class="text-center" (click)="selectMateriais(item.materialId)">
                  {{ item.descricao }} [{{ item.unidade }}]
                </td>
                <td class="text-center p-2">
                  <input id="q{{item.materialId}}" type="text" class="form-control fs11 text-center" digitOnly
                    maxlength="5" (change)="item.quantidade = $event.target.value" (change)="selectMateriais(item.materialId)" />
                  <span *ngIf="item.touched && item.quantidade == 0 && item.marcado" class="text-danger">
                    Campo obrigatório.
                  </span>
                </td>
                <td class="text-center p-2">
                   <input id="v{{item.materialId}}" type="text" currencyMask class="form-control fs11 wf120 text-right" maxlength="12" 
                   [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',', nullable: true, allowNegative: 'false'}" (change)="selectMateriais(item.materialId)"
                    /> 
                    <span *ngIf="item.touched && !item.valor && item.marcado" class="text-danger">
                      Campo obrigatório.
                    </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="mt-2" style="display: flex; justify-content: space-between">
          <section>
            <span *ngIf="this.materiaisListGrid.length < materiaisDisponiveis.length">
              Total materiais (filtrados):
            </span>
            <span *ngIf="this.materiaisListGrid.length == materiaisDisponiveis.length">
              Total materiais:
            </span>
            <span>
              <b>{{ this.materiaisListGrid.length | zerosEsquerda: 3 }}</b>
            </span>
          </section>

          <section>
            <span *ngIf="this.qtdSelecionados > 0">
              Selecionados: <b>{{this.qtdSelecionados}}</b>
            </span>
          </section>

        </div>
      </div>





      <div id="confirm-button" class="col-md-1 bg-gray1 cp" (click)="adicionarMateriais()"
        title="Inserir materiais selecionados"
        style="display: flex; flex-flow: column nowrap; align-items: center; justify-content: center; border: 2px solid #ddd; border-radius: 2px; margin-top: 15px; margin-bottom: 25px;">
        <button class="btn cp">
          <img src="./assets/images/arrow-right.png" />
        </button>
        <span class="text-muted txt-blue fs09">confirmar</span>
      </div>






      <div class="col-md-5">

        <div class="box-table fs09 mt-3" style="height: 405px;">
          <table>
            <thead>
              <tr>
                <th colspan="6">Materiais inseridos
                  <span *ngIf="this.materiaisSelecionados.length > 0"
                    class="badge badge-pill badge-warning pull-right pt-1">{{ this.materiaisSelecionados.length }}
                  </span>

              </tr>
              <tr>
                <th>Código / NCM</th>
                <th>Descrição</th>
                <th>Qtd</th>
                <th class="wf90">Valor</th>
                <th class="wf90">Total</th>
                <th class="wf20"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of materiaisSelecionados">
                <td class="text-center">
                  {{ item.codigo }} <br /> <b>{{item.ncm }}</b>

                </td>
                <td class="text-center">{{ item.descricao }}</td>
                <td class="text-center">{{ item.quantidade }}</td>
                <td class="text-right">{{ item.valor }}</td>
                <td class="text-right">{{ item.subTotal }}</td>
                

                <td class="text-center">
                  <button class="btn btn-sm" (click)="removerMateriais(item)" title="remover da lista">
                    <i class="fa fa-trash text-secoundary"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div style="display: flex; justify-content: space-between; padding-top: 10px;">
          <span>
            Total inseridos:
            <b>{{ materiaisSelecionados.length }}</b>
          </span>
          <span *ngIf="this.valorTotalMateriaisInseridos > 0">
            Valor total: <b>{{this.valorTotalMateriaisInseridos.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'})}}</b>
          </span>
        </div>
      </div>
    </div>
  </section>
</app-container-middle>

<div class="row mt-1">
  <div class="col-md-12">
    <div class="box"
      [ngClass]="{'box-primary': this.form.get('id').value == 0, 'box-warning': this.form.get('id').value > 0 }">
      <div class="box-body">
        <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-3 mb-3">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-3">
            <button type="button" class="btn btn-light btn-block" (click)="reset()">Limpar</button>
          </div>
          <div class="col-md-3">
            <button type="submit" class="btn btn-primary btn-shadow btn-block" form="form"
              [disabled]="(!(!(this.form.get('id').value > 0) && this.autorizacoes?.podeIncluir) && !(this.form.get('id').value > 0 && this.autorizacoes?.podeAlterar))"
              [ngClass]="{'btn-primary': !(this.form.get('id').value > 0), 'btn-warning': this.form.get('id').value > 0 }">
              <span *ngIf="!(this.form.get('id').value > 0)">Salvar</span>
              <span *ngIf="this.form.get('id').value > 0">Editar</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!--

  [disabled]="(!(!this.isEditing && this.autorizacoes?.podeIncluir) && !(this.isEditing && this.autorizacoes?.podeAlterar))"
-->

<ng-template #modalPesquisar let-c="close" let-d="dismiss">
  <div class="modal-header mh-primary">
    <h4 class="modal-title">
      Pesquisa por Número Documento
    </h4>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <form novalidate>

          <div class="form-row">
            <div class="form-group col-md-12">
              <label for="">Nº Documento (contém)</label>
              <div class="input-group input-group-lg mt-2">
                <input class="form-control borda-search" type="text" #numeroDocumento
                  (keyup.enter)="search($event.target.value)" />
                <div class="input-group-append">
                  <button type="button" class="btn btn-lg btn-primary borda-search"
                    (click)="search(numeroDocumento.value)">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="offset-md-3 col-md-9 text-center">
        <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
      </div>
    </div>

    <div class="row" *ngIf="nenhumResultadoEmPesquisa">
      <div class="col-md-12 text-center">
        <span class="text-danger">
          Nenhuma entrada material encontrada com este parâmetro
        </span>
      </div>
    </div>

    <section class="animated fadeInDown">
      <div class="row" *ngIf="this.searchResult.length > 0">
        <div class="col-md-12 text-center">
          <div class="divider"></div>

          <section>
            <h6 class="txt-blue">Selecione o documento para visualizar</h6>
          </section>

          <div class="divider"></div>

          <div class="box-table-sm h250">
            <table>
              <thead>
                <tr>
                  <th>Nº documento</th>
                  <th>Empresa</th>
                  <th>Data/Hora Entrada</th>
                </tr>
              </thead>
              <tbody class="text-center">
                <tr *ngFor="let doc of this.searchResult" (click)="exibirEntradaMaterial(doc.id, c)" class="cp">
                  <th>{{ doc.numeroDocumento }}</th>
                  <th>{{ doc.empresa }}</th>
                  <td>{{ doc.dataHoraEntrada | date:'dd/MM/yyyy HH:mm'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  </div>

  <div class="modal-footer">
    <div class="col-md-6"></div>

    <div class="col-md-6">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn btn-light btn-shadow btn-block" (click)="c('Close click')">
          Fechar
        </button>
      </div>
    </div>
  </div>
</ng-template>